/**
 * Team-CRM: Keine privaten Lead-Silos mehr — alle Nutzer sehen alle Leads.
 * Setter-Filter ist deaktiviert (null = volle Sicht).
 */
export function getSetterScopedLeadIds(_currentUser, _getStorage, _version = 0) {
  void _currentUser;
  void _getStorage;
  void _version;
  return null;
}

export function filterLeadsForSetter(leads, scopedIds) {
  if (!scopedIds) return leads;
  return leads.filter(l => scopedIds.has(String(l.id)));
}

export function filterListsForSetter(lists, scopedLeads) {
  const allowed = new Set(scopedLeads.map(l => l.list).filter(Boolean));
  return lists.filter(l => !l.hidden && (l.id === 'all' || l.id === 'top10' || allowed.has(l.id)));
}

export function buildCountsForLeads(leads, lists) {
  const c = { all: leads.length };
  lists.forEach(l => {
    if (l.id !== 'all') c[l.id] = leads.filter(lead => lead.list === l.id).length;
  });
  c.top10 = Math.min(10, leads.length);
  return c;
}
